import {Component, Input} from "@angular/core";

import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {FormsModule} from "@angular/forms";
import {ClearButtonComponent} from "../clear-button/clear-button.component";

@Component({
    selector: 'error-dialog',
    imports: [FontAwesomeModule, FormsModule, ClearButtonComponent],
    templateUrl: './error-dialog.html',
    styleUrls: ['./error-dialog.css']
})
export class ErrorDialogComponent {
  @Input('show') show: boolean = false
  @Input('error') error: string = ""
}
